import React from "react";

const images = [
  { src: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=400&h=250&q=80", alt: "Colorful salad bowl" },
  { src: "https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=400&h=250&q=80", alt: "Fresh vegetable salad" },
  { src: "https://images.unsplash.com/photo-1494390248081-4e521a5940db?auto=format&fit=crop&w=400&h=250&q=80", alt: "Yogurt bowl with berries" },
  { src: "https://images.unsplash.com/photo-1572357176061-7c96fd2af22f?auto=format&fit=crop&w=400&h=250&q=80", alt: "Green vegetables and avocado" },
  { src: "https://images.unsplash.com/photo-1493770348161-369560ae357d?auto=format&fit=crop&w=400&h=250&q=80", alt: "Fruit salad in bowls" },
  { src: "https://images.unsplash.com/photo-1557844352-761f2565b576?auto=format&fit=crop&w=400&h=250&q=80", alt: "Fresh vegetables and fruits" },
];

const FoodImageStrip = ({ variant = "dark" }) => {
  const bg = variant === "dark" ? "bg-[#0D1F17]" : "bg-[#F0F5F1]";

  return (
    <div className={`${bg} py-4 overflow-hidden`} data-testid="food-image-strip">
      <div className="flex gap-3 animate-scroll">
        {[...images, ...images].map((img, i) => (
          <div
            key={`food-${i}`}
            className="flex-shrink-0 w-48 h-28 md:w-56 md:h-32 rounded-xl overflow-hidden opacity-60 hover:opacity-100 transition-opacity duration-500"
          >
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FoodImageStrip;
